import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';
import {SketchPicker} from 'react-color';
import omit from 'lodash/omit';

import AutoSaveField from './abstract/AutoSaveField.jsx';
import {isNoU} from "../../../utils/DBUtils";
import OnBlurTextInput from "../BasicFormFields/OnBlurTextInput";

class AutoSaveColorSelector extends React.Component {

    constructor( props ) {
      super( props );
      this.state = {
        showColorPicker: false
      };
    }

    getValueFromOnChange = ( event, data ) => {
        console.log(event.hex);
      return event.hex;
    };

    getValueFromTextInputOnChange = ( event, data ) => {
      return event.target.value;
    };

    toggleColorPicker = () => {
      this.setState({ showColorPicker: !this.state.showColorPicker });
    };

    handleClose = () => {
      this.setState( { showColorPicker: false } );
    };

    onChangeComplete = ( color ) => {
      console.log(' color ', color)
    };

    allValidationRules() {
        return (this.props.validationRules || []).concat(
            {
                type: "HexColorFormat"
            }
        );
    }

    get placeholderText () {
      let placeholder = this.props.field && this.props.field.placeholderKey ? this.props.intl.formatMessage({ id: this.props.field.placeholderKey}) : null;
      return this.hasFallbackValue ? this.props.linkedValue : placeholder;
    }

    get hasValidDefaultValue() {
      return !isNoU(this.props.defaultValue) && this.props.defaultValue.trim() !== "";
    }

    render() {
        // Since we have 2 fields on this we need to omit the label from the 2nd one
        const colorPickerProps = omit( this.props, 'fieldLabel', 'helpContent', 'field.label', 'field.labelKey' );
        return (
          <div>
            <Grid className="external-inputs">
              <Grid.Column width={8}>
                <AutoSaveField  control={ OnBlurTextInput }
                                getValueFromOnChange={ this.getValueFromTextInputOnChange }
                                {...this.props}
                                placeholder={this.props.field && this.props.field.placeholderKey ? this.props.intl.formatMessage({ id: this.props.field.placeholderKey})  : ""}
                                usingLinkedValue={!isNoU(this.props.linkedValue) && !this.hasValidDefaultValue}
                                validationRules={this.allValidationRules()}
                                onClick={this.toggleColorPicker}
                                defaultValue={this.hasValidDefaultValue ? this.props.defaultValue : this.props.linkedValue}
                                />
            </Grid.Column>
            <Grid.Column width={1}>
            <button onClick={this.toggleColorPicker} style={{ backgroundColor: this.hasValidDefaultValue ? this.props.defaultValue : this.props.linkedValue}} className="db-color-picker-button">
               { this.state.showColorPicker}
            </button>

            { this.state.showColorPicker ?
              <div className="db-color-picker">
                <div style={{ position: 'fixed', top: 0, right: 0, bottom: 0, left: 0 }} onClick={ this.handleClose }></div>
                <AutoSaveField  control={ SketchPicker }
                                getValueFromOnChange={this.getValueFromOnChange}
                                color={this.hasValidDefaultValue ? this.props.defaultValue : this.props.linkedValue}
                                usingLinkedValue={!isNoU(this.props.linkedValue) && !this.hasValidDefaultValue}
                                presetColors= {this.props.breakColors}
                                {...colorPickerProps}
                />
              </div>
            : "" }
            </Grid.Column>
            </Grid>
          </div>
        );
    }
}

AutoSaveColorSelector.propTypes = {
    validationRules: PropTypes.arrayOf(PropTypes.object)
};

export default AutoSaveColorSelector;



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveColorSelector.jsx